<template>
    <div class="menu">
        <!-- 快捷菜单 -->
        <div class="quick-menu pc">
            <div class="menu-item">
                <div class="svg-item-home" @click="handleClick('/')">
                    <div class="home"></div>
                    <!-- <div class="svg-name">{{ $t('cart59') }}</div> -->
                </div>
                <div class="svg-item-message" @click="customer()">
                    <div class="message"></div>
                    <!-- <div class="svg-name">{{ $t('cart60') }}</div> -->
                </div>
                <div class="svg-item-add" @click="gohandleClick('/add')">
                    <div class="add"></div>
                    <!-- <div class="svg-name">{{ $t('cart61') }}</div> -->
                </div>
                <div class="svg-item-my" @click="handleClick('/member')">
                    <div class="my"></div>
                    <!-- <div class="svg-name">{{ $t('cart62') }}</div> -->
                </div>
                <div class="svg-item-dis" @click="openDiscord()">
                    <div class="dis"></div>
                    <!-- <div class="svg-name">{{ $t('cart62') }}</div> -->
                </div>
            </div>
        </div>
        <div class="cell-menu phone" v-if=" !routeArr.includes(currentRoute) && orderDetails">

            <div class="menu-item">
                <div class="svg-item" @click="handleClick('/')">
                    <div class="home">
                        <img v-if="currentRoute != '/'" src="../../assets/images/svghome.png" alt="" srcset="">
                        <img v-else src="../../assets/images/svghomes.png" alt="" srcset="">
                    </div>
                    <div :class="currentRoute != '/' ? 'svg-name' : 'checksvg-name'">{{ $t('cart59') }}</div>
                </div>
                <div class="svg-item" @click="handleClick('/category')">
                    <div class="category">
                        <img v-if="currentRoute != '/category'" src="../../assets/images/category.png" alt="" srcset="">
                        <img v-else src="../../assets/images/checkcategory.png" alt="" srcset="">
                    </div>
                    <div :class="currentRoute != '/category' ? 'svg-name' : 'checksvg-name'">{{ $t('cart81') }}</div>
                </div>
                <div class="svg-item" @click="handleClick('/cartlist')">
                    <div class="message">
                        <img v-if="currentRoute != '/cartlist'" src="../../assets/images/svgcart.png" alt="" srcset="">
                        <img v-else src="../../assets/images/svgcarts.png" alt="" srcset="">
                    </div>
                    <div class="em" v-if="cartStore.menuAllCount!=0">{{ cartStore.menuAllCount > 99 ? '···' :cartStore.menuAllCount}}</div>
                    <div :class="currentRoute != '/cartlist' ? 'svg-name' : 'checksvg-name'">{{ $t('cart63') }}</div>
                </div>
                <div class="svg-item" @click="handleClick('/member')">
                    <div class="my">
                        <img v-if="currentRoute != '/member'" src="../../assets/images/svgmy.png" alt=""
                            srcset="">
                        <img v-else src="../../assets/images/svgmys.png" alt="" srcset="">
                    </div>
                    <div :class="currentRoute != '/member' ? 'svg-name' : 'checksvg-name'">{{ $t('cart62') }}</div>
                </div>
            </div>
        </div>
    </div>
    <el-dialog v-model="loginModel" width="350" :before-close="handleClose">
        <loginView :loginType="1" @close="handleClose" :type="1"></loginView>
    </el-dialog>
</template>

<script setup>
import loginView from '@/components/loginView/index.vue'
import { defineComponent, watch, ref } from 'vue';
import { useUserStore } from '@/stores/userStore'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
const userStore = useUserStore()
import { useCartStore } from '@/stores/cartStore'
import { getContactDetailsAPI } from '@/apis/user'
const cartStore = useCartStore()
const router = useRouter()
const currentRoute = ref(router.currentRoute.value.path);
const loginModel = ref(false);
const discord = ref('');
const routeArr=[
    '/internal','/member/sell','/checkout','/webinfo/aboutUs','/webinfo/ShippingPolicy','/webinfo/pack','/userInfoPage','/setup','/member/publish','/member/collect','/collect',
    '/member/fan','/member/focusOn','/member/history','/address','/webinfo/termsOfService','/webinfo/paymentMethods','/webinfo/returnPolicy','/webinfo/privacyPolicy','/fan',
    '/publish','/focusOn','/PurchasingOrder','/MallOrder','/wallet','/sell',"/estimation","/member/MallOrder","/member/cartlist","/member/PurchasingOrder","/member/affiliate"
]

const isMobile = ref(false)
onMounted(() => {
    // npm install vue-meta@3.0.0-alpha.7
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
    getContactDetails()
})
const orderDetails = ref(true)

// 监听路由变化
watch(
    () => router.currentRoute.value.path,
    (newPath) => {

        if (newPath.startsWith('/orderDetails/') || newPath.startsWith('/externals/')||newPath.startsWith('/detail/')||newPath.startsWith('/category/sub/')||newPath.startsWith('/Payment')||newPath.startsWith('/usdPayment')||newPath.startsWith('/userDetails')) {
            console.log('进来了')
            orderDetails.value = false
        } else {
            orderDetails.value = true
        }
        currentRoute.value = newPath;
    }
);
/**
 * 获取联系方式
 */
 const getContactDetails = async () => {
    const res = await getContactDetailsAPI()
    if (res.code == 0) {
       
        if(res.data.data){
            discord.value=res.data.data[0]?.discord||''
            
        }
        // form.contactData = res.data.data[0]

    }

}
const handleClose = () => {
    loginModel.value = false
    window.location.reload();
}
const openDiscord = () => {
    console.log('discord.value',discord.value)
    window.open(discord.value);
}
const customer = () => {
    if (userStore.userInfo.token) {
        userStore.serviceStatus = true
    } else {
        // 2. 跳转到登录页
        loginModel.value = true
    }
}
const handleClick = (url) => {
    if (url == '/'||url == '/category') {
        router.push(url)
    } else {
        if (userStore.userInfo.token) {
            router.push(url)
        } else {
            router.push('/login')
        }
    }


}
const gohandleClick = (url) => {
    if (userStore.userInfo.token) {
        if (url == '/add') {
            if (userStore.userInfo.sellerType == 2) {
                ElMessage({ type: 'error', message: t('setup29') })
                return;
            }
        }
        if (isMobile == false) {
            // 打开新窗口
            let routeData = router.resolve({ path: url });
            window.open(routeData.href, '_blank');
        } else {
            router.push('/add')
        }

    } else {
        router.push('/login')
    }
}
</script>

<style scoped lang="scss">
.phone {
    display: none;
}

.quick-menu {
    position: fixed;
    top: 38%;
    right: 20px;
    background-color: rgb(238, 20, 20);
    padding: 10px;
    z-index: 999;
    width: 44px;
    // background: #fff;
    // box-shadow: 0 0 10px 1px rgba(0, 0, 0, .1);
    // border-radius: 8px;

    background: #FFFFFF;
box-shadow: -6px -3px 9px 0px rgba(218,222,223,0.5);
border-radius: 8px;
border: 1px solid #EEEEEE;



    .menu-item {
        display: flex;
        flex-direction: column;
        align-content: center;
        align-items: center;

        .svg-name {
            align-items: center;
            color: #1f1f1f;
            display: flex;
            font-size: 12px;
            font-weight: 500;
            height: 16px;
            justify-content: center;
            margin-top: 4px;
            width: 48px;
        }

        .svg-item-home {
            margin: 10px 0;
            // width: 56px;
            // height: 53px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            align-items: center;

            .home {
                background-image: url('@/assets/images/svghome.png');
                /* 背景图片覆盖整个容器，不留空白 */
                background-size: cover;
                /* 背景图片不平铺 */
                background-repeat: no-repeat;
                width: 19px;
                height: 21px;

            }



            &:hover {
                .home {
                    background-image: url('@/assets/images/svghomes.png');
                }

                .svg-name {
                   
                    color: #fc3938;
                }
            }


        }

        .svg-item-add {
            margin: 10px 0;
            // width: 56px;
            // height: 53px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            align-items: center;

            .add {
                background-image: url('@/assets/images/svgadd.png');
                /* 背景图片覆盖整个容器，不留空白 */
                background-size: cover;
                /* 背景图片不平铺 */
                background-repeat: no-repeat;
                width: 20px;
                height: 20px;
            }

            &:hover {
                .add {
                    background-image: url('@/assets/images/svgadds.png');
                }

                .svg-name {
                    color: #fc3938;
                }
            }


        }

        .svg-item-category {
            margin: 10px 0;
            // width: 56px;
            // height: 53px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            align-items: center;

            .category {
                background-image: url('@/assets/images/svgcategory.png');
                /* 背景图片覆盖整个容器，不留空白 */
                background-size: cover;
                /* 背景图片不平铺 */
                background-repeat: no-repeat;
                width: 19px;
                height: 21px;
            }



            &:hover {
                .category {
                    background-image: url('@/assets/images/svgcategorys.png');
                }

                .svg-name {
                    color: #fc3938;
                }
            }


        }

        .svg-item-my {
            margin: 10px 0;
            // width: 56px;
            // height: 53px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            align-items: center;

            .my {
                background-image: url('@/assets/images/svgmy.png');
                /* 背景图片覆盖整个容器，不留空白 */
                background-size: cover;
                /* 背景图片不平铺 */
                background-repeat: no-repeat;
                width: 19px;
                height: 22px;
            }



            &:hover {
                .my {
                    background-image: url('@/assets/images/svgmys.png');
                   
                }

                .svg-name {
                    color: #fc3938;
                }
            }


        }

        .svg-item-message {
            margin: 10px 0;
            // width: 56px;
            // height: 53px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            align-items: center;

            .message {
                background-image: url('@/assets/images/svgcategory.png');
                /* 背景图片覆盖整个容器，不留空白 */
                background-size: cover;
                /* 背景图片不平铺 */
                background-repeat: no-repeat;
                width: 19px;
                height: 21px;
            }



            &:hover {
                .message {
                    background-image: url('@/assets/images/svgcategorys.png');
                }

                .svg-name {
                    color: #fc3938#fc3938;
                }
            }


        }
        .svg-item-dis {
            margin: 10px 0;
            // width: 56px;
            // height: 53px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            align-items: center;

            .dis {
                background-image: url('@/assets/images/dis.png');
                /* 背景图片覆盖整个容器，不留空白 */
                background-size: 100% 100%;
                /* 背景图片不平铺 */
                background-repeat: no-repeat;
                width: 21px;
                height: 19px;
            }



            &:hover {
                .dis {
                    background-image: url('@/assets/images/sel-dis.png');
                }

                .svg-name {
                    color: #fc3938#fc3938;
                }
            }


        }
    }
}

/* 响应式设计 */
@media (max-width: 768px) {
    .pc {
        display: none;
    }

    .cell-menu {
        position: fixed;
        bottom: -1px;
        display: block;
        height: 70px;
        width: 100%;
        // background-color: rgb(238, 20, 20);
        padding: 10px;
        z-index: 999;
        background: #fff;
        // padding: 8px;
        box-shadow: 0 0 10px 1px rgba(0, 0, 0, .1);

        // border-radius: 8px;
        .menu-item {
            display: flex;
            flex-direction: row;
            align-content: center;
            align-items: center;
            justify-content: space-between;

            .svg-item {
                margin: 0px 0;
                width: 48px;
                height: 49px;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-around;
                position: relative;
                .home {
                    width: 21px;
                    height: 21px;
                }

                .add {
                    width: 21px;
                    height: 21px;
                }

                .message {
                    width: 20px;
                    height: 21px;
                   
                   
                }

                .category {
                    width: 19px;
                    height: 20px;
                }

                .my {
                    width: 20px;
                    height: 21px;
                }
                .em {
                        font-style: normal;
                        position: absolute;
                        // right: 0;
                        top: 0;
                        left: 27px;
                        // padding: 3px 5px;
                        // line-height: 1;
                        padding: 0;
                        width: 16px;
                        height: 16px;
                        line-height: 16px;
                        background:#FC3938;
                        color: #fff;
                        font-size: 10px;
                        border-radius: 50%;
                        font-family: Arial;
                        text-align: center;
                    }
            }

            .svg-name{
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 11px;
                color: #0F0F0F;
                line-height: 10px;
                text-align: left;
                font-style: normal;
            }
            .checksvg-name {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 11px;
                color: #FC3938;
                line-height: 10px;
                text-align: right;
                font-style: normal;
            }
        }

        img {
            background: #fff;
        }
    }
}
</style>
